import { BodyText, FlexRow } from '@make-software/cspr-design';

import React from 'react';
import { ContractIdentifier, HashFontSize } from '../../../components';
import { deriveSplitDataFromNamedKeyValue } from '../../../domain';
import { useGetContractInfo } from '../../../hooks/event-store-hooks';
import { isObject } from 'remeda';

const DeployActionCsprFun = ({ deploy }) => {
  const contractHash = isObject(
    deploy.args.token_to_trade_contract_hash_key.parsed
  )
    ? deploy.args.token_to_trade_contract_hash_key.parsed?.Hash
    : deploy.args.token_to_trade_contract_hash_key.parsed;

  const { hash } = deriveSplitDataFromNamedKeyValue(contractHash || '');
  // TODO: DERIVE
  const { data: contractPackageData } = useGetContractInfo({
    contract_hash: hash || '',
    includes: 'contract_package',
  });
  const contractPackageInfo = contractPackageData?.data?.contract_package;
  return (
    <FlexRow align={'center'} itemsSpacing={8}>
      <BodyText monotype size={3} wordBreak noWrap variation={'black'}>
        CSPR.fun trade
      </BodyText>

      <BodyText size={3} noWrap variation={'darkGray'}>
        with
      </BodyText>

      <FlexRow align={'center'} itemsSpacing={2}>
        <ContractIdentifier
          hash={contractPackageData?.data?.contract_package_hash}
          avatarSize={'small'}
          hashFontSize={HashFontSize.big}
          contractPackage={contractPackageInfo}
          hideContractIdentifier={false}
        />
      </FlexRow>
    </FlexRow>
  );
};

export default DeployActionCsprFun;
